// extracted by mini-css-extract-plugin
export default {"container":"Section6_container__wvmXG","innerContainer":"Section6_innerContainer__jJewI","image":"Section6_image__EkLYb","text":"Section6_text__Q7U48"};